import { ChevronRightIcon } from '@primer/octicons-react';
import { Text } from '@primer/react';

interface StatsCardProps {
    title: string
    count: number;
    renderValue?: (count: number) => React.ReactNode;
    isAllowClick: boolean
    onClick?: () => void;
}

export const StatsCard: React.FC<StatsCardProps> = ({ title, count, renderValue, isAllowClick, onClick }) => {
    const content = renderValue ? renderValue(count) : (
        <Text
            as="span"
            weight='medium'
            className='text-[20px] text-aloix-black whitespace-pre-line'>
            {count}
        </Text>
    );

    return (
        <div
            onClick={onClick}
            className={`
        bg-header
        border border-border
        rounded-lg
        px-3 py-3
        w-[288px]
        flex items-center justify-between
        transition-colors
        duration-200
        ${isAllowClick ? 'cursor-pointer hover:bg-gray-100' : 'cursor-default'}}
      `}
        >
            <Text as="span" weight='normal' className='text-[14px] text-aloix-grey whitespace-pre-line'>{title}</Text>

            <div className="flex items-center gap-3">
                {content}
                {isAllowClick && <ChevronRightIcon className="w-4 h-4" />}
            </div>
        </div>
    );
};